// Central tunable parameters. Keep implementation files free of magic numbers —
// if a designer might want to tweak something, it belongs here.

// ---------- World ----------
export const PLANET_R = 32;
export const PROP_COUNT = 380;

// ---------- Physics ----------
export const GRAVITY = 30;

// ---------- Character ----------
export const MOVE_SPEED = 0.25;    // rad/s over the sphere
export const TURN_SPEED = 1.3;
export const MOVE_ACCEL = 3.2;     // ground ramp-up rate (1/s)
export const MOVE_DECEL = 11;      // ground stopping rate (1/s)
export const TURN_ACCEL = 5.5;
export const TURN_DECEL = 13;
export const JUMP_V = 12;
export const CHAR_R = 0.28;        // horizontal collision radius

// Authority scalars for airborne control — preserves jump momentum.
export const MOVE_ACCEL_AIR_MULT = 0.25;
export const TURN_ACCEL_AIR_MULT = 0.55;

// Run cycle animation
export const RUN_PHASE_RATE = 7.5;   // cycles at full speed
export const RUN_SWING = 0.7;        // max leg/arm swing (rad)

// ---------- Camera ----------
export const CAM_BACK = 7;
export const CAM_HEIGHT = 3.6;
export const CAM_LOOK = 1.4;
export const CAM_FOLLOW_RATE = 5;    // lerp exponent per second

// ---------- Scene ----------
export const BACKGROUND_COLOR = 0x04081f;
export const FOG_COLOR = 0x4785bc;
export const FOG_NEAR = 15;
export const FOG_FAR = 80;

// ---------- Shooting stars ----------
export const SHOOTING_STAR_POOL = 8;
export const SHOOTING_STAR_MIN_DELAY = 1.2;
export const SHOOTING_STAR_MAX_DELAY = 5.7;
